import 'twin.macro';
import { useTranslation } from 'next-i18next';
import tw from 'twin.macro';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';

import { BaseModal, ButtonV2, Title } from '@restworld/ui-ds';

interface PPUEditInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDuplicate: () => void;
}

export function PPUEditInfoModal({ isOpen, onClose, onDuplicate }: PPUEditInfoModalProps) {
  const { t } = useTranslation('job-positions-page');

  const titleEl = (
    <Title
      content={t('ppu_edit_info_modal_title')}
      fontSize="extraLarge"
      fontWeight="semibold"
      textColor="neutral-700"
      twStyle={tw`text-center leading-[30px] px-4 sm:px-0`}
    />
  );

  const footerEl = (
    <div tw="flex flex-col justify-center items-center gap-4 w-full">
      <ButtonV2 variant="secondary-restworld" fullwidth StartIcon={DocumentDuplicateIcon} onClick={onDuplicate}>
        {t('ppu_edit_info_modal_duplicate_button')}
      </ButtonV2>
    </div>
  );

  return (
    <BaseModal
      showMobileGestures
      modalStyles={[tw`w-full max-w-[640px] lg:(max-w-screen-sm)`]}
      open={isOpen}
      onClose={onClose}
      title={titleEl}
      footer={footerEl}
    >
      <div tw="flex flex-col justify-center items-center gap-5 w-full text-center mt-6">
        <Title
          content={t('ppu_edit_info_modal_description')}
          fontSize="base"
          fontWeight="medium"
          textColor="neutral-700"
          twStyle={tw`whitespace-pre-line`}
        />
      </div>
    </BaseModal>
  );
}

export default PPUEditInfoModal;
